import {useMemo, useState} from "react";
import {FleetAssetCapabilityType} from "@ots-frontend/ots-data";
import {useDebouncedValue} from "@mantine/hooks";
import {
  DataTableFilterConfig,
  useDataTableFilter,
  UseDataTableFilterProps,
  UseDataTableFilterResult
} from "../DataTable/useDataTableFilter";
import {useTranslation} from "react-i18next";
import { getFormattedDatabaseCode } from "../../text/FormattedDatabaseCode/FormattedDatabaseCode";

export type UseFleetAssetCapabilityDataTableFilterProps = Omit<UseDataTableFilterProps<FleetAssetCapabilityType>, 'filterConfig'>

export function useFleetAssetCapabilityDataTableFilter(props: UseFleetAssetCapabilityDataTableFilterProps): UseDataTableFilterResult<FleetAssetCapabilityType> {
  const {records} = props;

  const {t} = useTranslation(["common"])

  const [nameQuery, setNameQuery] = useState<string | undefined>(undefined);
  const [nameDebouncedQuery] = useDebouncedValue(nameQuery, 200);

  const filterConfig: DataTableFilterConfig<FleetAssetCapabilityType> = useMemo(() => {
    return {
      "name": {
        setQuery: setNameQuery,
        query: nameQuery,
        debouncedQuery: nameDebouncedQuery,
        filter: (record, query) => {
          const display = getFormattedDatabaseCode(record, t)
          return !record.code.toLowerCase().includes(query.toLowerCase()) || !display || !display.toLowerCase().includes(query.toLowerCase())
        }
      },
    }
  }, [
    nameQuery,
    nameDebouncedQuery,
    t
  ])

  const {filteredRecords} = useDataTableFilter({
    records: records,
    filterConfig: filterConfig,
  })

  return {
    filteredRecords: filteredRecords,
    filterConfig: filterConfig
  };
}
